import { forwardRef } from "react";

const SIZE_ALIASES = {
  sm: "small",
  md: "medium",
  lg: "large",
};

const IconButton = forwardRef(function IconButton({
  label,
  size = "medium",
  className = "",
  children,
  ...props
}, ref) {
  const normalizedSize = SIZE_ALIASES[size] || size;

  return (
    <button
      ref={ref}
      className={`ds-icon-button ds-icon-button--${normalizedSize}${className ? ` ${className}` : ""}`}
      aria-label={label}
      title={label}
      {...props}
    >
      {children}
    </button>
  );
});

export default IconButton;
